/**
 * Brand mark for the Shini Extra Middleware Platform. Variants:
 *
 *   <Brand variant="full" />     full lockup with "MIDDLEWARE PLATFORM" caption
 *   <Brand variant="compact" />  compact horizontal wordmark, used in the topbar
 *   <Brand variant="icon" />     square favicon-style mark (Shini "S")
 */

const RED = "#d6202b";
const RED_DARK = "#a51820";

function ShiniExtraWordmark({ height = 28, color = RED, accent = RED_DARK }) {
  // SHINI in bold sans-serif + "extra" in a flowing script tail.
  const w = height * 4.8;
  return (
    <svg
      width={w}
      height={height}
      viewBox="0 0 240 50"
      role="img"
      aria-label="Shini Extra"
    >
      <text
        x="0"
        y="38"
        fontFamily="'Inter', 'Helvetica Neue', Arial, sans-serif"
        fontWeight="900"
        fontSize="40"
        letterSpacing="-1"
        fill={color}
      >
        SHINI
      </text>
      <text
        x="128"
        y="40"
        fontFamily="'Brush Script MT', 'Lucida Handwriting', cursive"
        fontStyle="italic"
        fontWeight="700"
        fontSize="38"
        fill={accent}
      >
        extra
      </text>
    </svg>
  );
}

export function Brand({ variant = "compact", captionColor, ...rest }) {
  if (variant === "icon") {
    return (
      <svg
        width={rest.size || 32}
        height={rest.size || 32}
        viewBox="0 0 64 64"
        role="img"
        aria-label="Shini Extra"
        {...rest}
      >
        <rect width="64" height="64" rx="14" fill={RED} />
        <text
          x="32"
          y="44"
          textAnchor="middle"
          fontFamily="'Inter', sans-serif"
          fontWeight="900"
          fontSize="34"
          fill="#fff"
          letterSpacing="-1"
        >
          S
        </text>
      </svg>
    );
  }

  if (variant === "full") {
    return (
      <div
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 6,
        }}
        {...rest}
      >
        <ShiniExtraWordmark height={52} />
        <div
          style={{
            fontFamily: "'Inter', sans-serif",
            fontWeight: 600,
            fontSize: 11,
            letterSpacing: "4px",
            textTransform: "uppercase",
            color: captionColor || "var(--mantine-color-dimmed)",
          }}
        >
          Middleware Platform
        </div>
      </div>
    );
  }

  // compact (default) — used in the topbar
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "baseline",
        gap: 8,
        whiteSpace: "nowrap",
      }}
      {...rest}
    >
      <ShiniExtraWordmark height={24} />
      <span
        style={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 600,
          fontSize: 10,
          letterSpacing: "3px",
          textTransform: "uppercase",
          color: captionColor || "var(--mantine-color-dimmed)",
        }}
      >
        Middleware
      </span>
    </div>
  );
}
